import { makeActionCreator } from '../../utils/actionsUtils';
import { HEADER_TOGGLE_MENU_MOBILE_SLIDE } from './constants';

// affiche ou cache le menu mobile du coté
export const toggleMenuMobileSlide = makeActionCreator(
    HEADER_TOGGLE_MENU_MOBILE_SLIDE,
    'versionMenu'
);



// WEBPACK FOOTER //
// ./src/services/header/actions.js